module.exports = __webpack_public_path__ + "img/img5.0d8568a1.png";